/**
 * @generated SignedSource<<ad4ab9010764dc813b1706f9cda864d2>>
 * @relayHash e073c9376c4722f57e08bd86687b319f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77d479fed117c675085e4612debc56b213c0af828603a13a32055e279861405c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavQueueInnerExperimentQuery } from './HorizontalNavQueueInnerExperimentQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavQueueInnerExperimentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "77d479fed117c675085e4612debc56b213c0af828603a13a32055e279861405c",
    "metadata": {},
    "name": "HorizontalNavQueueInnerExperimentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
